import React, {useEffect, useState} from "react";

import "./course.module.cmp.scss";
import courseComander from "../../../store/commanders/course.comander";
import PLButton from "../../common/button/PLButton";
import { cleanModuleTitle } from "../../../helpers/course.helper";
import { useTranslation } from "react-i18next";



const CourseModuleCmp = ({selected}) => {
    const { t } = useTranslation();
    const cleanedTitle = cleanModuleTitle(selected.title);
    
    return <div className="marks-bg">
        <div className="">
            {/* Module Title Header with Next Button */}
            <div className="module-header">
                <h2 className="module-title">{cleanedTitle}</h2>
                <PLButton
                    onClick={() => {
                        courseComander.ac_next_lesson()
                        courseComander.cmd_update_lastSeen(selected.id)
                    }}
                    variant="primary"
                    size="lg"
                    className="next-lesson-btn"
                >
                    {t("common.next")}
                </PLButton>
            </div>
            
            <div className="module-description">{selected.description}</div>
        </div>
    </div>;
}
export default CourseModuleCmp;
